import { GuardId } from '../../components/loadingAtoms.js';
import { useGuardLoadingState } from '../../hooks/useGuardLoadingState.js';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';

/**
 * Signout form component that automatically signs out the user when rendered,
 * then redirects to the given destination.
 */
function SignoutForm({ redirectDestination, onBeforeSignOut }) {
    const { signOut } = useAuth();
    const navigate = useNavigate();
    // Show global loading spinner during signout
    useGuardLoadingState(GuardId.AUTH, true);
    useEffect(() => {
        const performSignout = async () => {
            try {
                if (onBeforeSignOut) {
                    await Promise.resolve(onBeforeSignOut());
                }
                await signOut();
                navigate(redirectDestination, { replace: true });
            }
            catch (error) {
                console.error('Error signing out:', error);
                // Still redirect so user is not stuck
                navigate(redirectDestination, { replace: true });
            }
        };
        performSignout();
    }, [signOut, navigate, redirectDestination, onBeforeSignOut]);
    // Return null - the global LoadingPage spinner will be visible
    return null;
}

export { SignoutForm };
//# sourceMappingURL=SignoutForm.js.map
